import React from 'react';

import { createClassName } from 'utils/createClassName';
import { ReactComponent as ArrowLeftIcon } from 'svg/arrow-left.svg';

import './backControlStyles.scss';

type Props = {
  onPress(): void;
};

export const BackControlComponent = (props: Props) => {
  const { onPress } = props;

  const className = createClassName('backControl')();

  const handleClick = React.useCallback(() => {
    onPress();
  }, [onPress]);

  return (
    <button type="button" className={className} onClick={handleClick}>
      <ArrowLeftIcon />
    </button>
  );
};
